import { PropsWithChildren } from 'react';

import { StyledLink } from '~/components/ui/link/styled';
import { COLORS } from '~/styles/colors';

type LinkProps = PropsWithChildren<{
  to: string;
  color?: string;
  underline?: boolean;
  fontSize?: number;
  fontWeight?: number;
}>;

export const Link = ({
  to,
  color = COLORS.primary,
  underline = false,
  fontSize = 16,
  children,
  fontWeight = 500,
}: LinkProps) => {
  return (
    <StyledLink to={to} $color={color} $underline={underline} $fontSize={fontSize} $fontWeight={fontWeight}>
      {children}
    </StyledLink>
  );
};
